module.exports = __webpack_public_path__ + "static/office_4-0ccd9f0b7051a7e1dcaea6907f88aa33.png";